// extracted by mini-css-extract-plugin
export default {"container":"MGuiV","block-big":"olFR2","block-small":"LuvFl","image":"ck0Sq","title":"E3PHt","hub":"aQ72M"};